import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { styleVariables } from '../../style';
import styled from '@xstyled/styled-components';
import { AppLogo } from './logo.component';
import { jsx as _jsx } from "react/jsx-runtime";
var AppLogoHeaderContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  height: 53px;\n  width: 100%;\n  background: ", ";\n  justify-content: center;\n  align-items: center;\n"])), styleVariables.colors.blue4);
export var AppLogoHeader = function AppLogoHeader(props) {
  var logoSrc = props.logoSrc;
  return /*#__PURE__*/_jsx(AppLogoHeaderContainer, {
    children: /*#__PURE__*/_jsx(AppLogo, {
      srcImg: logoSrc
    })
  });
};